'use es6';

import ActionTypes from './ActionTypes';
import PortalIdParser from 'PortalIdParser';
import { isUserEnrolledInGettingStarted } from 'onboarding-utils/gettingStartedEnrollment';
import { setOnboardingSettings } from 'user-context/onboardingSettings';
import { getDefaultOnboardingSettings } from 'growth-onboarding-signup-redirect/utils/onboardingKeyUtils';
import { makeDebouncedAction } from '../utils/ActionUtils';
export const getIsEnrolledInGettingStartedRequesting = () => ({
  type: ActionTypes.GETTING_STARTED_GET_REQUESTING
});
export const getIsEnrolledInGettingStartedReceived = response => ({
  type: ActionTypes.GETTING_STARTED_GET_RECEIVED,
  payload: {
    isEnrolledInGettingStarted: response
  }
});
export const getIsEnrolledInGettingStartedError = () => ({
  type: ActionTypes.GETTING_STARTED_GET_ERROR
});
export const enrollInGSError = () => ({
  type: ActionTypes.GETTING_STARTED_ENROLL_ERROR
});
export const getIsEnrolledInGettingStarted = makeDebouncedAction(dispatch => {
  dispatch(getIsEnrolledInGettingStartedRequesting());
  isUserEnrolledInGettingStarted().then(response => dispatch(getIsEnrolledInGettingStartedReceived(response)), errorResponse => dispatch(getIsEnrolledInGettingStartedError(errorResponse))).catch(err => {
    setTimeout(() => {
      throw err;
    });
  });
  return undefined;
}, 3000, {
  leading: true,
  trailing: false
});
export const setUserGuideSettingsAndReturnUrl = (view, experience) => (dispatch, getState) => {
  const userId = getState().auth.user.user_id;
  const onboardingSettings = getDefaultOnboardingSettings({
    crmExperience: experience
  });
  onboardingSettings.selectedView = view;
  const activeGroupKey = onboardingSettings.views[view].groupKey;
  return setOnboardingSettings(onboardingSettings, userId).then(() => {
    dispatch(getIsEnrolledInGettingStartedReceived(true));
    return `/user-guide/${PortalIdParser.getPortalIdFromPath()}?activeTab=${view}&groupKey=${activeGroupKey}&enroll=true`;
  }).catch(errorResponse => dispatch(enrollInGSError(errorResponse)));
};